import { toRem } from 'helpers/theme'

/* eslint-disable quote-props */

const listMargin = 20

const style = ({ theme, columns }) => ({
    overflow: 'hidden',
    '& .staffList': {
        display: 'flex',
        flexDirection: 'column',
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        [theme.breakpoints.up('520')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginLeft: toRem(-listMargin / 2),
            marginRight: toRem(-listMargin / 2)
        },
        ...(columns === 4 && {
            justifyContent: 'center'
        }),
        '&-item': {
            position: 'relative',
            flexBasis: '100%',
            marginBottom: toRem(40),
            [theme.breakpoints.up('520')]: {
                marginBottom: toRem(40),
                marginRight: toRem(listMargin / 2),
                marginLeft: toRem(listMargin / 2),
                maxWidth: `calc((100% / 2) - ${toRem(listMargin)})`,
                ...(columns === 4 && {
                    marginBottom: toRem(60)
                })
            },
            [theme.breakpoints.up('md')]: {
                ...((columns === 2 || columns === 4) && {
                    maxWidth: `calc((100% / 3) - ${toRem(listMargin)})`
                })
            },
            [theme.breakpoints.up('lg')]: {
                ...(columns === 2 && {
                    maxWidth: `calc((100% / 2) - ${toRem(listMargin)})`
                }),
                ...(columns === 4 && {
                    maxWidth: `calc((100% / 4) - ${toRem(listMargin)})`
                })
            }
        }
    }
})

export default style
